import React, {useRef}  from 'react';

import ImgUploadForm from 'views/ImgUploadForm';
import UserAPI from 'service/api/UserAPI';
import {Title} from 'views/AppElements';

const BannerForm = ({id, bannerImg}) => {
    const deleteBtn = useRef(null);

    const onUpload = function(uploadedImgFile) {
        UserAPI.addBanner(uploadedImgFile);
    };

    const onDelete = function() {
        deleteBtn.current.setAttribute("disabled", true);
        deleteBtn.current.innerHTML = "<i class='fa fa-circle-o-notch fa-spin' aria-hidden='true'></i>";
        UserAPI.removeBanner(bannerImg);
    };
    return  <div>
                {
                    bannerImg &&
                    <button onClick={onDelete} style={{cursor: "pointer", backgroundColor: "#cccccc", color: "white", borderRadius: "5px", fontSize: "80%"}} key={bannerImg} ref={deleteBtn}>X</button>
                }
                
                <ImgUploadForm previewId={id} className="bannerPicForm" 
                                    defaultPreviewImg={bannerImg} 
                                    imgWidth="800px" imgHeight="209px"
                                    imgInfo="1196 x 312, Less than 2Mb"
                                    onUpload={onUpload} addOnly={true} />
                
    </div>
};


const BannersForm = ({bannerImages, storeName}) => {
    let bannerImageForms = [];
    for(var i = 0; i < 3; i++) {
        const key = storeName+"Banner"+i;
        const img = bannerImages? bannerImages[i]: null;
        bannerImageForms[i] = <BannerForm key={key} id={key} bannerImg={img} /> 
        
        if(!img)
            break;
    }

    return <div>
        <Title title="Store Banners" style={{textAlign: 'left'}} separatorPosition="top" />
        {bannerImageForms}
    </div>
}

export default BannersForm;


// WEBPACK FOOTER //
// ./src/views/user/BannersForm.js